import Image from "next/image";
import checkWhite from "../../assets/icons/check-white-bg.png";

const Sidebar = ({ step }: { step: number }) => {
  const steps = ["Basic Details", "Address", "KYC"];

  // Background images for each step
  const bgImages = [
    "/bg-sidebar-desktop.svg",
    "/bg-sidebar-desktop.svg",
    "/bg-sidebar-desktop.svg",
  ];

  return (
    <div
      className="text-white-1 p-6 rounded-l-lg flex flex-col gap-6 w-64 bg-cover bg-center relative"
      style={{ backgroundImage: `url('${bgImages[step - 1] || bgImages[0]}')` }}
    >
      {/* Logo */}
      <Image
        quality={50}
        property="no"
        unoptimized
        src="https://cyclecircle.one/static/media/Cycle-Circle-Logo-White-1.d371c720871713f32fd9.png"
        alt="Cycle Circle Logo"
        width={75}
        height={30}
        className="mx-auto"
      />

      {/* Steps */}
      <div className="relative flex flex-col gap-6">
        {steps.map((label, index) => {
          const isCompleted = step > index + 1;
          const isActive = step === index + 1;

          return (
            <div key={index} className="flex items-center gap-3 relative">
              {/* Step Indicator (Green Tick for Completed, Number for Active & Upcoming) */}
              <span
                className={`w-8 h-8 flex items-center justify-center rounded-full text-sm font-bold z-10
                  ${isCompleted ? "bg-white-1": isActive ? "bg-white-1 text-blue" : "border border-white-1 bg-blue"}`}
              >
                {isCompleted ? (
                  <Image src={checkWhite} alt="check-icon" width={30} height={30} className="p-1"/>
                ) : (
                  index + 1
                )}
              </span>

              {/* Step Label */}
              <span
                className={`uppercase text-xs ${
                  isActive || isCompleted ? "text-white-1 font-bold" : "text-gray-200"
                }`}
              >
                {label}
              </span>

              {/* Connector Line */}
              {index !== steps.length - 1 && (
                <div className="absolute left-4 top-8 w-[2px] h-12 bg-white-1"></div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Sidebar;
